var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal-card", staticStyle: { width: "auto" } },
    [
      _c(
        "button",
        {
          staticClass: "button is-warning is-small",
          on: {
            click: function ($event) {
              return _vm.$parent.close()
            },
          },
        },
        [
          _c("b-icon", { attrs: { icon: "chevron-left" } }),
          _c("span", [_vm._v(_vm._s(_vm.$t("global.back")))]),
        ],
        1
      ),
      _c(
        "VueLeafletMap",
        {
          attrs: {
            markers: _vm.filteredMarkers,
            name: "leaflet",
            "map-type": "pickup",
            "selected-group": _vm.selectedGroup.collectGroup,
            "selected-marker": _vm.selectedMarker,
          },
        },
        [
          _c("map-filter", {
            attrs: { markers: _vm.markers },
            on: {
              "filter-changed": (markers) => (_vm.filteredMarkers = markers),
              "marker-selected": _vm.focusOnMarker,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }